class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.hasInitialized = false;
    this.initAttempts = 0;
    this.tryInitialization();
  }

  tryInitialization() {
    // Strategy 1: Immediate initialization - no delays
    this.init();
    
    // Strategy 2: Use initLazyScript if available (as backup)
    if (typeof window.initLazyScript === 'function') {
      window.initLazyScript(this, this.init.bind(this), 100);
    }
    
    // Strategy 3: Use IntersectionObserver (as backup)
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasInitialized) {
            observer.disconnect();
            this.init();
          }
        });
      }, { rootMargin: '200px' });
      observer.observe(this);
    }
  }

  async init() {
    if (this.hasInitialized) {
      return;
    }
    
    this.hasInitialized = true;
    this.initAttempts++;
    
    const { productId } = this.dataset;
    if (!productId) {
      return;
    }

    const url = `${this.dataset.url}&product_id=${productId}&_=${Date.now()}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'text/html,application/xhtml+xml',
          'Cache-Control': 'no-cache'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const responseText = await response.text();

      if (responseText.length === 0) {
        return;
      }

      const tmpl = document.createElement('template');
      tmpl.innerHTML = responseText;

      const el = tmpl.content.querySelector('product-recommendations');
      
      if (el) {
        if (el.hasChildNodes()) {
          this.innerHTML = el.innerHTML;

          // Re-initialize buy-box listeners on the newly injected cards.
          // buyo_init() binds click handlers to .buyo_option / .buyo_btn etc.
          // and normally only runs once on DOMContentLoaded, so async-loaded
          // recommendations need it called again or their buy buttons and
          // pricing-tier disclosure won't respond to clicks.
          if (typeof window.buyo_init === 'function') {
            window.buyo_init();
          }

          // Dispatch custom event for analytics/tracking if needed
          this.dispatchEvent(new CustomEvent('recommendations-loaded', {
            detail: { success: true, productsCount: el.querySelectorAll('.card').length }
          }));
        } else {
          this.innerHTML = '<div class="container"><p class="text-center text-muted">No related products found.</p></div>';
        }
      }
    } catch (error) {
      console.error('ProductRecommendations fetch error:', error);
      this.hasInitialized = false; // Allow retry
      
      // Quick retry
      if (this.initAttempts < 2) {
        setTimeout(() => this.init(), 500);
      }
    }
  }
}

// Only define if not already defined
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}